import { queryOptions } from "@tanstack/react-query";

import { getDataFromResponse } from "~/api/axiosUtils.ts";
import {
	getClientContactPerson,
	indexClientContactPersons,
	indexClientContactPersonsByClient,
	indexClientContactPersonsByCompany,
} from "~/modules/client/api/clientContactPerson/clientContactPersonApiDispatchers.ts";

export const clientContactPersonQueries = {
	baseKey: ["client-contact-person"],
	all: () =>
		queryOptions({
			queryKey: [...clientContactPersonQueries.baseKey, "all"],
			queryFn: () => indexClientContactPersons().then(getDataFromResponse),
		}),
	byId: (clientContactPersonId: string) =>
		queryOptions({
			queryKey: [...clientContactPersonQueries.baseKey, "byId", clientContactPersonId],
			queryFn: () => getClientContactPerson(clientContactPersonId).then(getDataFromResponse),
			enabled: !!clientContactPersonId,
		}),
	byClient: (clientId: string) =>
		queryOptions({
			queryKey: [...clientContactPersonQueries.baseKey, "client", clientId],
			queryFn: () => indexClientContactPersonsByClient(clientId).then(getDataFromResponse),
			enabled: !!clientId,
		}),
	byCompany: (companyId: string) =>
		queryOptions({
			queryKey: [...clientContactPersonQueries.baseKey, "company", companyId],
			queryFn: () => indexClientContactPersonsByCompany(companyId).then(getDataFromResponse),
			enabled: !!companyId,
		}),

};